import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Feature from '../common/Feature';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import Testimonial from './common/Testimonial';
import TotalProductCount from './common/TotalProductCount';
// import OptInPopup from "../components/OptInPopup";
import config from "../../config";
import InView from "../common/InView";
import {buildEcomProductArrayForTopProducts, pushNewEcommerceEvent} from "../../utils/datalayer";

class Category extends Component {
	constructor(props) {
		super(props);
		this.handleTopProductsInview = this.handleTopProductsInview.bind(this);
	}
	handleTopProductsInview() {
		const {featuredProduct} = this.props;
		const items = buildEcomProductArrayForTopProducts(featuredProduct, 'Security Safes');
		pushNewEcommerceEvent('view_item_list', items);
	}
	render() {
		const pageTitle = 'Security Safes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<InView onInView={this.handleTopProductsInview}>
					<TopProducts
						title={`Best Selling ${pageTitle}`}
						subTitle="Feel confident in the security of your valuables"
						path="security-safes"
						buttonCTA={`View all ${pageTitle}`}
						topProduct={this.props.featuredProduct}
					/>
				</InView>
			);
		}

		return (
			<div className="category category-security">
				<Helmet defer={false}>
					<title>{pageTitle} &#124; SentrySafe</title>
					<meta name="description" content="Our security safes offer extra protection against theft or burglary to safeguard your most valued belongings. View security safes." />
					<script async src={config.bazaarVoiceScriptUrl} />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={pageTitle} />
				</Breadcrumb>

				<Hero
					imageSrc={require('../../resources/img/hero/security-safes.jpg')}
					imageAlt="Man with tablet"
					title={pageTitle}
					description="Reliable protection for the things you value most."
				/>

				<TrustedSection
					content="Everyone owns something they can&#39;t imagine losing &#8211; photos, meaningful jewelry, valuable keepsakes. That&rsquo;s why we offer a wide range of security products to help you protect and organize the valuables you want to safeguard. SentrySafe Security Safes are designed to keep cash, records, valuables, pistols, and more, secure against theft or burglary."
				/>

				{topProducts}

				<section className="row features">
					<div className="col sm-12">
						<h2 className="title">Strong Protection. Convenient Features</h2>
					</div>
					<div className="callouts">
						<Feature
							title="Multiple Live-Locking Bolts"
							description="Live-locking bolts provide advanced protection against theft and unauthorized users."
							image={require('../../resources/img/features/bolt.png')}
						/>
						<Feature
							title="Bolt Down Hardware"
							description="Bolt down hardware ensures thieves cannot easily remove the safe from your home or office."
							image={require('../../resources/img/features/bolt-down.png')}
						/>
						<Feature
							title="Digital Lock"
							description="Programmable digital locks that let you choose your own unique combination."
							image={require('../../resources/img/features/digital-lock.png')}
						/>
						<Feature
							title="Steel Construction"
							description="Steel construction for durable and reliable protection."
							image={require('../../resources/img/features/steel-construction.png')}
						/>
					</div>
				</section>

				<Testimonial
					imgSrc1={require('../../resources/img/callouts/did-you-know-breakin.png')}
					alt1="Flood"
					imgSrc2={require('../../resources/img/callouts/testimonial-quote.png')}
					alt2="Quote"
					quote="We were recently burgled and the perpetrators had a very good attempt at breaking into our SentrySafe&#59; however, they did not succeed in getting the contents only in destroying the product. They finally gave up the attempt but we were able to open the safe and take out our valuable documents. We will definitely be replacing this item with another SentrySafe. Thanks for a great product."
					submitted="Klaus T."
					readLink="View all SentrySafe Stories"
					link="/learn/customer-stories" />

				<TotalProductCount
					link="security-safes"
					productTotal={totalCount}
					name={pageTitle}
				/>
				{/*<OptInPopup />*/}
			</div>
		);
	}
}

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/SecurityCategory.js